import { IProjectMemoRes } from '../model';

export const DEFAULT_DETAIL_PROJECT_MEMO: IProjectMemoRes = {
  id: '',
  projectId: '',
  emoNumber: '',
  supportTypeId: '',
  folder: '',
  memo: '',
  version: '',
  location: '',
  visaCategories: []
};

export const DEFAULT_KEY_JOIN_VISA_CATEGORY = ', ';
